import React from 'react';
import usePlaceholderTraceStore from './usePlaceholderTraceStore';
import getPlaceholderColors from '../../utils/placeholderColors';
import PlaceholderTraceOverlay from './PlaceholderTraceOverlay';

const baseStyle = {
  flex: 1,
  minWidth: 0,
  minHeight: 0,
  position: 'relative',
};

const PlaceholderTraceCanvasWrapper = ({ children }) => {
  const activeKey = usePlaceholderTraceStore((s) => s.activeKey);
  const type = usePlaceholderTraceStore((s) => s.type);
  const traceColor = type ? getPlaceholderColors(type).default : undefined;

  const style = traceColor
    ? { ...baseStyle, '--placeholder-trace-color': traceColor }
    : baseStyle;

  return (
    <div
      style={style}
      className={activeKey ? 'placeholder-trace-active' : undefined}
    >
      {children}
      <PlaceholderTraceOverlay />
    </div>
  );
};

export default PlaceholderTraceCanvasWrapper;
